import React, { useState, useEffect } from 'react';
import AdminLogin from '../components/AdminLogin';
import AddProductForm from '../components/AddProductForm';
import ProductsList from '../components/ProductsList';
import ShopManager from '../components/ShopManager';
import AdminShopsManage from '../components/AdminShopsManage';
import Dashboard from '../components/Dashboard';
import ManufacturerManager from '../components/ManufacturerManager';
import ProductTypeManager from '../components/ProductTypeManager';
import BatchScraper from '../components/BatchScraper';
import AdminUsersManager from '../components/AdminUsersManager';
import AdminPriceManager from '../components/AdminPriceManager';
import ScrapeErrors from '../components/ScrapeErrors';
import ServerStatus from '../components/ServerStatus';
import AdminAuth from '../services/AdminAuth';
import './AdminPage.css';

function AdminPage() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [activeTab, setActiveTab] = useState('products');
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    // Prüfe ob Admin authentifiziert ist
    if (AdminAuth.isAdmin()) {
      setIsAdmin(true);
    }
  }, []);

  const handleLoginSuccess = () => {
    setIsAdmin(true);
    setRefreshKey(prev => prev + 1);
  };

  const handleLogout = () => {
    AdminAuth.logout();
    setIsAdmin(false);
    setActiveTab('products');
  };

  const handleProductAdded = () => {
    setRefreshKey(prev => prev + 1);
  };

  if (!isAdmin) {
    return <AdminLogin onLoginSuccess={handleLoginSuccess} />;
  }

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>🔐 Admin Dashboard</h1>
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>

      <div className="admin-layout">
        {/* Linke Sidebar Navigation */}
        <aside className="admin-sidebar">
          <nav className="admin-nav">
            <button
              className={`nav-item ${activeTab === 'server-status' ? 'active' : ''}`}
              onClick={() => setActiveTab('server-status')}
            >
              <span className="nav-icon">🖥️</span>
              <span className="nav-label">Server Status</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'dashboard' ? 'active' : ''}`}
              onClick={() => setActiveTab('dashboard')}
            >
              <span className="nav-icon">📊</span>
              <span className="nav-label">Dashboard</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'batch-scraper' ? 'active' : ''}`}
              onClick={() => setActiveTab('batch-scraper')}
            >
              <span className="nav-icon">🔄</span>
              <span className="nav-label">Batch Scraper</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'scrape-errors' ? 'active' : ''}`}
              onClick={() => setActiveTab('scrape-errors')}
            >
              <span className="nav-icon">❌</span>
              <span className="nav-label">Kein Preis</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'products' ? 'active' : ''}`}
              onClick={() => setActiveTab('products')}
            >
              <span className="nav-icon">📦</span>
              <span className="nav-label">Produkte hinzufügen</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'manage' ? 'active' : ''}`}
              onClick={() => setActiveTab('manage')}
            >
              <span className="nav-icon">🏪</span>
              <span className="nav-label">Produkte verwalten</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'manufacturers' ? 'active' : ''}`}
              onClick={() => setActiveTab('manufacturers')}
            >
              <span className="nav-icon">🏭</span>
              <span className="nav-label">Hersteller verwalten</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'product-types' ? 'active' : ''}`}
              onClick={() => setActiveTab('product-types')}
            >
              <span className="nav-icon">🏷️</span>
              <span className="nav-label">Produkttypen verwalten</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'prices' ? 'active' : ''}`}
              onClick={() => setActiveTab('prices')}
            >
              <span className="nav-icon">💰</span>
              <span className="nav-label">Preise verwalten</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'shops' ? 'active' : ''}`}
              onClick={() => setActiveTab('shops')}
            >
              <span className="nav-icon">🛒</span>
              <span className="nav-label">Shops verwalten</span>
            </button>
            
            <button
              className={`nav-item ${activeTab === 'users' ? 'active' : ''}`}
              onClick={() => setActiveTab('users')}
            >
              <span className="nav-icon">👥</span>
              <span className="nav-label">User verwalten</span>
            </button>
          </nav>
        </aside>

        {/* Main Content Area */}
        <div className="admin-content" key={refreshKey}>
        {activeTab === 'server-status' && (
          <section className="admin-section">
            <ServerStatus />
          </section>
        )}

        {activeTab === 'dashboard' && (
          <section className="admin-section">
            <Dashboard />
          </section>
        )}

        {activeTab === 'batch-scraper' && (
          <section className="admin-section">
            <BatchScraper />
          </section>
        )}

        {activeTab === 'scrape-errors' && (
          <section className="admin-section">
            <ScrapeErrors />
          </section>
        )}

        {activeTab === 'products' && (
          <section className="admin-section">
            <h2>Neues Produkt hinzufügen</h2>
            <AddProductForm onProductAdded={handleProductAdded} />
          </section>
        )}

        {activeTab === 'manage' && (
          <section className="admin-section">
            <h2>Produkte verwalten</h2>
            <ProductsList key={refreshKey} />
          </section>
        )}

        {activeTab === 'manufacturers' && (
          <section className="admin-section">
            <ManufacturerManager />
          </section>
        )}

        {activeTab === 'product-types' && (
          <section className="admin-section">
            <ProductTypeManager />
          </section>
        )}

        {activeTab === 'prices' && (
          <section className="admin-section">
            <AdminPriceManager />
          </section>
        )}

        {activeTab === 'shops' && (
          <section className="admin-section">
            <h2>Shops & Bewertungen verwalten</h2>
            <AdminShopsManage key={refreshKey} />
          </section>
        )}

        {activeTab === 'users' && (
          <section className="admin-section">
            <h2>User verwalten</h2>
            <AdminUsersManager />
          </section>
        )}
      </div>
      </div>
    </div>
  );
}

export default AdminPage;
